<script lang="ts">
  import BaseModule from '$src/js/modules/base/BaseModule';

  interface HeroSkinSelectorProps {
    onchange?: (index: 0 | 1) => void;
  }

  const { onchange }: HeroSkinSelectorProps = $props();

  let active: 0 | 1 = $state(0);

  const select = (index: 0 | 1): void => {
    active = index;
    onchange?.(index);
  };
</script>

<div
  class="absolute bottom-[calc(var(--vh)*100-272px)] left-1/2 z-10 flex -translate-x-1/2 gap-6 sm:bottom-[calc(100svh-272px)] md:bottom-14 lg:bottom-18"
>
  <button
    class="gradient-border gradient-border--rounded gradient-border--animated relative flex h-12 w-[120px] items-center rounded-full p-2 transition-all duration-300 sm:h-14 sm:w-[136px] {active ===
    1
      ? 'bg-white'
      : 'bg-black'}"
    onclick={() => select(active === 0 ? 1 : 0)}
  >
    <div
      class="absolute h-8 w-8 rounded-full transition-all duration-300 sm:h-10 sm:w-10 {active === 1
        ? 'left-2 bg-black'
        : 'left-[calc(100%-40px)] bg-white sm:left-[calc(100%-48px)]'}"
    ></div>

    <div
      class="{active === 1
        ? 'visible opacity-100'
        : 'invisible opacity-0'} absolute top-1/2 w-[calc(100%-16px)] -translate-y-1/2 pl-10 text-center text-xs leading-[150%] font-extrabold tracking-[0.175em] whitespace-nowrap text-black uppercase transition-all duration-300 sm:text-sm"
    >
      {BaseModule.getInstance().i18n.translate('hero_switch_light')}
    </div>
    <div
      class="{active === 0
        ? 'visible opacity-100'
        : 'invisible opacity-0'} absolute top-1/2 w-[calc(100%-16px)] -translate-y-1/2 pr-10 text-center text-xs leading-[150%] font-extrabold tracking-[0.175em] whitespace-nowrap uppercase transition-all duration-300 sm:text-sm"
    >
      {BaseModule.getInstance().i18n.translate('hero_switch_dark')}
    </div>
  </button>
</div>
